import React from "react";
import "./Scoring.css";

const Scoring = () => {
  return (
    <div className="scoringContainer">
      <h1>Scoring</h1>
      <li>
        The Chameleon escapes undetected: 3 points for the chameleon and 1 point
        for those who correctly voted for them, despite being in the minority.
        The Chameleon gets 2 bonus points for winning if they started the round.
      </li>
      <br></br>

      <li>
        The Chameleon is caught but guesses the secret word: 1 point for the
        Chameleon.
      </li>
      <br></br>

      <li>
        The Chameleon is caught and doesn't know the secret word: 2 points for
        everyone but the Chameleon.
      </li>
      <br></br>
    </div>
  );
};

export default Scoring;
